import { render, staticRenderFns } from "./changeDate.vue?vue&type=template&id=0fc6f4d9&scoped=true&"
import script from "./changeDate.vue?vue&type=script&lang=js&"
export * from "./changeDate.vue?vue&type=script&lang=js&"
import style0 from "./changeDate.vue?vue&type=style&index=0&id=0fc6f4d9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc6f4d9",
  null
  
)

export default component.exports